import React, { Component } from 'react'
import { withStyles, Drawer, Typography, Divider, TextField, Button, AppBar, Toolbar, IconButton,Switch, FormGroup, FormControlLabel, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

const drawerWidth = 500;

const styles = theme => ({
    root: {
        width: drawerWidth,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '100%'
    },
    textStyle: {
        fontWeight: 400
    },
    paddingForm: {
        padding: '20px'
    }
})

class LeaveAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            leave_type: '',
            leave_desc: '',
            no_of_days: 0,
            is_renewal: 0,
            id: '',
            chec: false
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeS = this.onChangeS.bind(this);

    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onChangeS(e) {
        let is_renewal = this.state.is_renewal;
        if(e.target.checked){
            is_renewal = 1
        }else{
            is_renewal = 0
        }
        
        this.setState({
            chec: e.target.checked,
            is_renewal
        })
        
    }

    componentDidMount() {
        if (this.props.edit) {
            this.setState({
                ...this.props.edit_data
            })
        } else {
            this.setState({
                leave_type: '',
                leave_desc: '',
                no_of_days: 0,
                is_renewal: 0,
                id: '',
                chec: false
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.edit !== this.props.edit) {
            if (this.props.edit) {
                this.setState({
                    ...this.props.edit_data,
                    chec: this.props.edit_data.is_renewal
                })
            } else {
                this.setState({
                    leave_type: '',
                    leave_desc: '',
                    no_of_days: 0,
                    is_renewal: 0,
                    id: '',
                    chec: false
                })
            }
        }
    }


    onSubmit(e) {
        e.preventDefault();

        const data = this.state;

        if (this.props.edit) {
            this.props.esetData(data);

        } else {
            this.props.setData(data);
            this.setState({
                leave_type: '',
                leave_desc: '',
                no_of_days: 0,
                is_renewal: 0,
                id: '',
                chec: false
            })
        }

    }

    onDeleteClick(id){
        this.props.onDeleteClick(id);
    }

    render() {
        let { classes } = this.props;
        return (
            <div>
                <Drawer
                    className={classes.root}
                    anchor="right"
                    open={this.props.show}
                    onClose={this.props.handleClose}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >

                    <AppBar position="static" color={this.props.edit ? "secondary" : "primary"} >
                        <Toolbar>
                            <Typography variant="h6" color="inherit" >
                                {this.props.edit ? "Edit DATA" : "Add New"}
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    <div className={classes.paddingForm}>

                        <form onSubmit={this.onSubmit}>

                            {/* <FormControl className={classes.formControl}>
                                <InputLabel shrink className={classes.textStyle}>Select Type</InputLabel>
                                <Select
                                    value={this.state.is_teaching}
                                    onChange={this.onChange}
                                    name="is_teaching"
                                    inputProps={{
                                        name: 'is_teaching'
                                    }}

                                >
                                    <MenuItem value="">
                                        <em>Choose Type</em>
                                    </MenuItem>
                                    <MenuItem value="1">Teaching</MenuItem>
                                    <MenuItem value="0">Non-Teaching</MenuItem>
                                </Select>
                            </FormControl> */}


                            <TextField
                                label="Leave Name"
                                name="leave_type"
                                className={classes.textField}
                                type="text"
                                autoComplete="current-password"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                InputProps = {{
                                    readOnly: this.props.edit
                                }}
                                value={this.state.leave_type}
                                onChange={this.onChange}
                            />

                            <TextField
                                label="Description"
                                className={classes.textField}
                                type="text"
                                name="leave_desc"
                                autoComplete="current-password"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.leave_desc}
                                onChange={this.onChange}
                            />

                            <TextField
                                label="No of Days"
                                className={classes.textField}
                                type="text"
                                name="no_of_days"
                                autoComplete="current-password"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.no_of_days}
                                onChange={this.onChange}
                            />


                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            name="is_renewal"
                                            checked={this.state.chec}
                                            onChange={this.onChangeS}
                
                                        />
                                    }
                                    label="is renewable ?"
                                />
                                </FormGroup>

                            <br />
                            <div>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    color={this.props.edit ? "secondary" : "primary"}
                                    className={classes.button}>
                                    {this.props.edit ? "Update" : "Submit"}
                                </Button>

                                {this.props.edit ?
                                    <span>&nbsp;
                                    <Button
                                            type="button"
                                            variant="contained"
                                            color="secondary"
                                            className={classes.button}
                                            onClick={this.onDeleteClick.bind(this,this.props.edit_data.id)}
                                            >
                                            Delete
                                    </Button>
                                    </span>

                                    : null}
                            </div>
                        </form>

                    </div>



                </Drawer>
            </div>
        )
    }
}

export default withStyles(styles)(LeaveAdd)